import React from 'react';
import _get from 'lodash/get';
import smbUtils from './smbUtils';
import i18n from 'i18next';
import langUtils from './langUtils';
import {multipleSubscriptionsUtils} from './solutionUtils';

const getSubscriptionType4PurchaseNow = st =>
  st === 'ESSENTIAL_TRIAL' ? 'ESSENTIAL' : 'PREMIUM';

const prefix =
  smbUtils.getUrl() + langUtils.convertToFrontendLangUrl(i18n.language);
const utils = {
  getCurrentAffiliation: auth => _get(auth, 'affiliations', []),
  noSubscription: auth => !auth.subscriptionItem,
  isTrialPlan: auth =>
    _get(auth, 'subscriptionItem.subscription.isTrialPlan', false),
  isPremiumPlan: auth =>
    _get(auth, 'subscriptionItem.subscription.isPremiumPlan', false),
  getLeftDays: auth => _get(auth, 'subscriptionItem.leftDays', 0),
  isOverdue: auth => {
    const subscriptionItems = _get(auth, 'subscriptionItems', []);
    const overdueSolutions = multipleSubscriptionsUtils.overdueSolutions(auth);
    return overdueSolutions.length === subscriptionItems.length;
  },
  isRenewable: auth => {
    const value = _get(auth, 'subscriptionItem.subscription.isRenewable');
    return value === 'True' || value === 'true' || value === true;
  },
  getSubscriptionType: auth =>
    _get(
      auth,
      'subscriptionItem.subscription.subscriptionType',
      'ESSENTIAL_TRIAL'
    ),
  getMaxNumberOfSkus: auth => _get(auth, 'subscriptionItem.numOfSkus', 0),
  getMaxNumberOfLooks: auth => _get(auth, 'subscriptionItem.numOfLooks', 0),
  getMaxNumberOfLicenses: auth =>
    _get(auth, 'subscriptionItem.numOfLicenses', 0),
  getMaxNumberOfStaffAccounts: auth =>
    _get(auth, 'subscriptionItem.numOfStaffs', 0),
  getPurchaseNowUrl: (auth, campaign = 'subscribe-now', customerId = '') =>
    `${prefix}${smbUtils.frontendLanguage()}/business/user/sign-up?platform=STANDARD&isSubscribe=true&currencyType=USD&subscriptionType=${getSubscriptionType4PurchaseNow(
      utils.getSubscriptionType(auth)
    )}&recurringType=ANNUAL&utm_source=smb&utm_campaign=${campaign}&utm_content=${customerId}`,
  getSkincareVersion: auth => _get(auth, 'brandInfo.templateVersion', 1),
  isSkincareVersionAbove2: auth => utils.getSkincareVersion(auth) >= 2, //crm + sd
  isSkincareVersionAbove2AndHd: auth =>
    utils.getSkincareVersion(auth) >= 2 &&
    _get(auth, 'brandInfo.recommendationAbility', 'SD') === 'HD', //crm + hd
  isSupportHdSubOptions: auth =>
    utils.isSkincareVersionAbove2AndHd(auth) &&
    (_get(
      _get(
        multipleSubscriptionsUtils.getSolutionInfos(auth),
        'SKIN_ANALYSIS',
        []
      ),
      'isPremiumPlan',
      'false'
    ) ||
      utils.isEnterprise(auth)),
  canEnableSku: (auth, numberOfEnabled) => {
    if (numberOfEnabled == null) {
      return false;
    }
    return utils.getMaxNumberOfSkus(auth) > numberOfEnabled;
  },
  canEnableLook: (auth, numberOfEnabled) => {
    if (numberOfEnabled == null) {
      return false;
    }
    return utils.getMaxNumberOfLooks(auth) > numberOfEnabled;
  },
  canCreateStaff: (auth, numberOfStaffAccounts = -1) => {
    if (numberOfStaffAccounts === -1) {
      return false;
    }
    if (_get(auth, 'customer.functionType') === 'SKINCARE_PRO') {
      return (
        multipleSubscriptionsUtils.getTotalMaxNumberOfStaffs(auth) >
        numberOfStaffAccounts
      );
    }
    if (utils.isTrialPlan(auth)) {
      return false;
    }
    return utils.getMaxNumberOfStaffAccounts(auth) > numberOfStaffAccounts;
  },
  isUniqueUsersVersion: auth =>
    _get(auth, 'customer.isUserLimitEnabled', false),
  isEnterprise: auth => {
    return utils.getSubscriptionType(auth) === 'ENTERPRISE';
  },
  enterpriseEnabledDetectionCategory: auth => {
    const subscriptionItem = auth.subscriptionItems.find(
      r => r.subscription.solutionType === 'SKIN_ANALYSIS'
    );
    if (
      _get(subscriptionItem, 'subscription.subscriptionType') === 'ENTERPRISE'
    ) {
      return _get(subscriptionItem, 'attrs.skincareProConcerns', []);
    }
    return [];
  },
  getRole: auth => {
    return _get(auth, 'account.role', null);
  },
  isOwnerRole: auth => {
    return (
      _get(auth, 'isSuperAccount', false) || utils.getRole(auth) === 'OWNER'
    );
  },
  getRoleId: auth => {
    return _get(auth, 'account.id', null);
  },
  getCurrencyType: billings => {
    return _get(billings.find(r => r !== null), 'currencyType');
  },
  getPaymentType: subscriptionItem => {
    return _get(subscriptionItem, 'subscription.paymentType', 'STRIPE');
  },
};

export default utils;
